<div
  class="order-preparation-page-container">
  @switch (preparationStep) {
    @case ('RequireDestination') {
      <section>
        <!-- ============== RequireDestination ============== -->
        <app-order-preparation-confirmation [order]="order"></app-order-preparation-confirmation>
        <form [formGroup]="destinationForm"
          (ngSubmit)="onSubmitDestination()"
          class="flex-column gap-10">
          <app-order-preparation-destination-input [preparationSettings]="preparationSettings$ | async"
            formControlName="destination"
            appearance="fill"
          [readonly]="inProgress"></app-order-preparation-destination-input>
          <button type="submit"
            mat-flat-button
            class="confirm-destination-button"
            color="accent"
            [disabled]="inProgress">
            <span>{{ "COMMON.CONFIRM" | transloco }}&nbsp;</span>
            @if (inProgress) {
              <app-loader></app-loader>
            }
          </button>
        </form>
      </section>
    }
    @case ('PromptForAction') {
      <section>
        <!-- ============== PromptForAction ============== -->
        <app-order-preparation-header [order]="order"
          [orderPreparation]="orderPreparation"
        [loadingOrderPreparation]="loadingOrderPreparation"></app-order-preparation-header>
        <app-order-preparation-prompt-for-action [order]="order"
          [orderPreparation]="orderPreparation"
          [loading]="inProgress"
        #actionSelector></app-order-preparation-prompt-for-action>
        <div class="action-buttons-panel">
          <button (click)="onConfirmSelectedAction(actionSelector.selectedAction)"
            mat-flat-button
            class="confirm-button"
            color="accent"
            [disabled]="inProgress || actionSelector.selectedAction === null">
            <span>{{ "COMMON.CONFIRM" | transloco }}&nbsp;</span>
            @if (inProgress) {
              <app-loader></app-loader>
            }
          </button>
          <button type="button"
            class="main-button"
            mat-button
            (click)="onAddArticlesClicked()">
            {{ "COMMON.CLOSE" | transloco }}
          </button>
        </div>
      </section>
    }
    @case ('DisplayConfirmation') {
      <section>
        <!-- ============== DisplayConfirmation ============== -->
        <app-order-preparation-confirmation [order]="order"></app-order-preparation-confirmation>
        <app-order-preparation-header [expanded]="true"
          [order]="order"
          [orderPreparation]="orderPreparation"
        [loadingOrderPreparation]="loadingOrderPreparation"></app-order-preparation-header>
        <button (click)="onOkCloseClicked()"
          mat-flat-button
          class="confirm-button"
          color="accent">
          <span>{{ "COMMON.CLOSE" | transloco }}&nbsp;</span>
          @if (inProgress) {
            <app-loader></app-loader>
          }
        </button>
      </section>
    }
    @default {
      <section>
        <!-- ============== Default / Loading ============== -->
        <app-page-loader></app-page-loader>
      </section>
    }
  }
</div>
